import { parsePhoneNumber } from 'react-phone-number-input';

import { SalesStage } from '../../../Model/Lead';
import { CHALLENGE_ENDED_CANCELLATION_SOURCE } from './constants';

/**
 * Mirrors BLOCKING_REASONS in system2-server functions-22/src/leadCampaign/utils/audience-eligibility.ts
 * — age and gender — and the rules behind them in functions-22/src/utils/lead.ts
 * (processDisqualification), including the 18/100 age defaults. The two must move together: this
 * drives the previewed recipient count, the server drives what actually sends, and the operator
 * confirms the preview's number before an irreversible blast.
 *
 */
const isUnfitForCoach = (lead, coachData) => {
  const { leadDisqualificationConfig, isEnrolledInISProgram = false } = coachData;

  if (!isEnrolledInISProgram) return false;

  const {
    age: { min: minAllowedAge = 18, max: maxAllowedAge = 100 } = {},
    disallowedGenders = [],
  } = leadDisqualificationConfig ?? {};

  const leadAge = Number(lead.age);
  if (leadAge < minAllowedAge || leadAge > maxAllowedAge) return true;
  return disallowedGenders.length > 0 && disallowedGenders.includes(lead.gender ?? '');
};

export const hasUsableFirstName = (firstName) => Boolean(firstName?.trim());

export const isTextableLead = (lead, coachData) => {
  if (lead.removed === true || !lead.phoneNumber || lead.smsOptedOut === true) return false;
  return lead.salesStage !== SalesStage.UNQUALIFIED || !isUnfitForCoach(lead, coachData);
};

export const isClientInCountries = (phoneNumber, countries) => {
  const parsed = parsePhoneNumber(phoneNumber, 'US');
  if (!parsed?.isValid()) return false;
  return countries.includes(parsed.country);
};

export const isTextableClient = (user) => Boolean(user.phoneNumber)
  && user.cancellationSource !== CHALLENGE_ENDED_CANCELLATION_SOURCE;
